// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Dhsx","boxTitle":"Qualiphy_boxTitle__1nRBY","box":"Qualiphy_box__1MIU7","toggleWrap":"Qualiphy_toggleWrap__5GezM"};